<template>
  <div class="community__q">
        <div class="community__q--pic">
            <img :src="`${$store.state.apiUrl}/images/profil/small/${post.createdBy.profilePicture.split('.')[0]}.webp`" alt="" class="community__q--img">
        </div>
        <div class="community__q--content">
            <div class="community__q--text">
                <router-link :to="{name:'Post', params:{slug:post.slug}}" class="community__q--question">
                    {{post.locales ? post.locales[$store.state.language] && post.locales[$store.state.language].title  ? capitalizeFirstLetter(post.locales[$store.state.language].title) : capitalizeFirstLetter(post.title) : capitalizeFirstLetter(post.title)}}
                </router-link>
                <h4 class="community__q--data">
                    <div class="u-phone-hide">
                        <router-link :to="{name:'User', params:{slug:post.createdBy.slug}}" class="community__q--link btn__text">{{post.createdBy.name}}</router-link>
                        {{t('card.publish')}}
                        <router-link :to="{name:'Community'}" class="community__q--link btn__text">{{post.category}}</router-link>
                    </div>
                    <span class="community__q--data-span">{{moment(post.createdAt).locale($store.state.language).fromNow()}}</span>    
                    <span class="community__q--data-span u-phone-hide">{{post.countLikes}} {{t('card.like')}}{{post.countLikes>1 ? 's': ''}}</span>
                    <span class="community__q--data-span u-phone-hide">{{post.commentCount}} {{t('card.comment')}}{{post.commentCount>1 ? 's': ''}}</span>
                    <router-link :to="{name:'Post', params:{slug:post.slug}}" class="btn__text community__q--reply">{{t('card.cta')}}</router-link>
                </h4>
            </div>
            <button class="community__q--action" :class="{'community__q--action-liked': userLike}" @click.stop="likePost" aria-label="like post">
                <Svg className="community__q--action-svg" icon="like"></Svg>
            </button>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

import Svg from '../utils/Svg';
import { useStore } from 'vuex';
import { ref } from 'vue';
import moment from 'moment';

import {capitalizeFirstLetter} from '../../composables/utils/capitalize';
import { useI18n } from 'vue-i18n';

import en from "@/locales/en/post/post.json";
import fr from "@/locales/fr/post/post.json";

export default {
    components:{Svg},
    props:['post'],
    setup(props){
        const {t} = useI18n({
            messages:{
                en:en,
                fr:fr
            }
        })
        const store = useStore();
        const postData = ref(props.post);
        const userLike = ref(postData.value.likes.includes(store.state.user._id));
        const likePost = async () => {
            if(store.state.loggedIn){
                try{
                    let method = 'POST';
                    if(userLike.value){
                        method = 'DELETE';
                    }

                    const res = await axios({
                        method,
                        url:'posts/like/'+props.post._id
                    })

                    if(res.status == '201'){
                        userLike.value  = true;
                        postData.value.countLikes ++;
                    } else if(res.status == '204'){
                        userLike.value  =  false;
                        postData.value.countLikes --;
                    }
                }catch(err){
                    console.log(err.response);
                }
            }else{
                store.commit('showSignupPopup');
            }
        }

        return {capitalizeFirstLetter, likePost, moment, postData, t, userLike}
    }
}
</script>

<style lang="scss">
@import '@/style/main';

.community{
    &__q{

        position: relative;
        padding: 1.8rem 4rem;
        border: 2px solid $color-grey-65;
        box-shadow: $shadow;

        &:not(:last-child){
            margin-bottom: 2rem;
        }
        &--pic{
            position: absolute;
            left: 0;
            top: 50%;

            transform: translate(-50%, -50%);
            width: 4.7rem;
            height: 4.7rem;
            border-radius: 50%;
            background-color: $color-white;;
            display: flex;
            align-items: center;
            justify-content: center;
            
            &-icon{
                border: 1px solid $color-blue-light;
            }

            &-svg{
                color:$color-blue-light;
                @include svg(3rem);
            }

        }
        &--img{

            width: 4rem;
            height: 4rem;
            border-radius: 50%;
        }

        &--empty{
            font-size: 1.6rem;
        }

        &--content{
            display: flex;
            align-items: center;
        }

        &--text{
            display: flex;
            flex-direction: column;
        }
        &--question{
            font-size: 1.6rem;
            letter-spacing: .5px;
            margin-bottom: .5rem;
            font-weight: 700;
            text-decoration: none;
            color: inherit;
        }
        &--data{
            display: flex;
            flex-wrap: wrap;
            font-weight: 400;
            font-size: 1.4rem;
            &-span{

                &:first-of-type{
                    padding-left: 1rem;
                    &::before{
                        content: "\2022";
                        padding-right: 1rem;
                    }

                    @include respond(phone){
                        padding-left: 0;
                        &::before{
                            display: none;
                        }
                    }
                }
                
                &::after{
                    padding-left: 1rem;
                    content: "\2022";
                    padding-right: 1rem;
                }

            }

            @include respond(phone){
                // flex-direction: column;
            }
        }
        &--link{
            font-weight: 700;

        }

        &--reply{
            color: $color-blue-light !important;
            text-transform: uppercase;
            letter-spacing: .1rem;
        }

        &--action{
            margin-left: auto;
            background: none;
            color: inherit;
            border: none;
            padding: 0;
            padding-left: 1rem;
            font: inherit;
            cursor: pointer;
            outline: inherit;

            transition: all .2s;
            &:hover{
                color:$color-blue-light
            }

            &-liked{
                color:$color-blue-light;
                animation: like .3s ease-in-out;
            }
            &-svg{
                @include svg(2.5rem);
            }

        }
    }
}

</style>